import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class Banner {
    constructor() {
        this.section = document.querySelector('.modulo-banner');
        
        this.slider = this.section.querySelector('.swiper--banner');
        this.navigationPrev = document.querySelector('.slider-button-prev--banner');
        this.navigationNext = document.querySelector('.slider-button-next--banner');

        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });
    }

}

if (document.querySelector('.modulo-banner')) {
    new Banner();
}